var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee text-no-wrap",style:({'background-color':_vm.props.color})},[_c('span',{style:({animationDuration: ((_vm.props.length * 0.15 || 15) + "s")})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }